export default {
  flightList: [
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-09T07:50:00",
                airport: {
                  code: "CWB",
                  name: "Afonso Pena",
                  city: "Curitiba",
                },
              },
              arrival: {
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-09T07:50:00",
                    airport: {
                      code: "CWB",
                      name: "Afonso Pena",
                      city: "Curitiba",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "2089",
                },
              ],
            },
            recordLocator: "JCNRVY",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-09T06:40:00",
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "San Pablo",
                },
              },
              arrival: {
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-09T06:40:00",
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "San Pablo",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "1002",
                },
              ],
            },
            recordLocator: "IZJONR",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-09T03:40:00",
                airport: {
                  code: "REC",
                  name: "Gilberto Freyre  (Guararapes)",
                  city: "Recife",
                },
              },
              arrival: {
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "San Pablo",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-09T03:40:00",
                    airport: {
                      code: "REC",
                      name: "Gilberto Freyre  (Guararapes)",
                      city: "Recife",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "San Pablo",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "1553",
                },
              ],
            },
            recordLocator: "IWCYEE",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-08T07:50:00",
                airport: {
                  code: "CWB",
                  name: "Afonso Pena",
                  city: "Curitiba",
                },
              },
              arrival: {
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-08T07:50:00",
                    airport: {
                      code: "CWB",
                      name: "Afonso Pena",
                      city: "Curitiba",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "2089",
                },
              ],
            },
            recordLocator: "KXOBYR",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-02T21:05:00",
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                },
              },
              arrival: {
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "San Pablo",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-02T21:05:00",
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "San Pablo",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "1067",
                },
              ],
            },
            recordLocator: "NVHAMH",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-02T13:00:00",
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "San Pablo",
                },
              },
              arrival: {
                airport: {
                  code: "SDU",
                  name: "Santos Dumont",
                  city: "Rio de Janeiro",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-02T13:00:00",
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "San Pablo",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "SDU",
                      name: "Santos Dumont",
                      city: "Rio de Janeiro",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "1026",
                },
              ],
            },
            recordLocator: "NVHAMH",
          },
        ],
      },
    },
    {
      flight: {
        chosenFlightSegmentList: [
          {
            type: "SEGMENT_1",
            chosenFlight: {
              airline: {
                code: "G3",
                name: "GOL LINHAS AEREAS",
              },
              departure: {
                date: "2023-05-02T07:10:00",
                airport: {
                  code: "CGH",
                  name: "Congonhas",
                  city: "San Pablo",
                },
              },
              arrival: {
                airport: {
                  code: "REC",
                  name: "Gilberto Freyre  (Guararapes)",
                  city: "Recife",
                },
              },
              legList: [
                {
                  departure: {
                    date: "2023-05-02T07:10:00",
                    airport: {
                      code: "CGH",
                      name: "Congonhas",
                      city: "San Pablo",
                    },
                  },
                  arrival: {
                    airport: {
                      code: "REC",
                      name: "Gilberto Freyre  (Guararapes)",
                      city: "Recife",
                    },
                  },
                  marketingAirline: {
                    code: "G3",
                    name: "GOL LINHAS AEREAS",
                  },
                  flightNumber: "1510",
                },
              ],
            },
            recordLocator: "IWCYEE",
          },
        ],
      },
    },
  ],
  page: {
    limit: 8,
    offset: 0,
    hasMore: false,
  },
};
